import { HTTP_STATUS } from '../response';
import { Error } from '../error';

export interface FacebookConfirmResponse {
	status: HTTP_STATUS;
	playerId?: number;
	errors?: Error[];
}

export type FacebookConfirmAction = () => Promise<FacebookConfirmResponse>;
